import { render, staticRenderFns } from "./general-fields.vue?vue&type=template&id=7b53a96e&scoped=true&"
import script from "./general-fields.vue?vue&type=script&lang=js&"
export * from "./general-fields.vue?vue&type=script&lang=js&"
import style0 from "./general-fields.vue?vue&type=style&index=0&id=7b53a96e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b53a96e",
  null
  
)

export default component.exports